import { Box, Portal, Typography } from '@mui/material'
import { useAtom } from 'jotai'
import { modalAtom } from '../common/jotaiState/globalStateAtoms'
export const ShortcutsPopup = (props) => {
  const [, setModal] = useAtom(modalAtom)
  const { shortcutsPopupRef } = props
  const { dropPortalStyle } = props
  const rect = shortcutsPopupRef.current.getBoundingClientRect()
  const portalstyle = { ...dropPortalStyle, right: window.innerWidth - rect.right }
  const modeClose = () => setModal()
  return (
    <Portal container={document.getElementById('root')}>
      <Box className="model--wrapper" style={{ top: '52px' }} onClick={modeClose}>
        <Box className="profile-section" style={portalstyle}>
          <Box className="profile-items" style={{ display: 'flex' }}>
            <Typography varient="p" flexGrow={1} style={{ fontSize: '15px', fontWeight: 500 }}>
              Go to Book Button
            </Typography>
            <Typography
              varient="p"
              className="shortcuts-text"
              flexGrow={0}
              style={{ width: '130px', fontSize: '15px', fontWeight: 500, marginLeft: '10px' }}
            >
             : Ctrl + Shift + b
            </Typography>
          </Box>

          <Box className="profile-items" style={{ border: 0, display: 'flex' }}>
            <Typography varient="p" flexGrow={1} style={{ fontSize: '15px', fontWeight: 500 }}>
              Go to Consignment Type
            </Typography>
            <Typography
              varient="p"
              className="shortcuts-text"
              flexGrow={0}
              style={{ width: '130px', fontSize: '15px', fontWeight: 500, marginLeft: '10px' }}
            >
             : Ctrl + Shift + c
            </Typography>
          </Box>
        </Box>
      </Box>
    </Portal>
  )
}